// extracted by mini-css-extract-plugin
export var confirmationHeader = "_ww-0";
export var confirmationIcon = "_ww-1";